import { render, staticRenderFns } from "./IconUserEmail.vue?vue&type=template&id=898eae12"
import script from "./IconUserEmail.vue?vue&type=script&lang=js"
export * from "./IconUserEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports